import { Head, useForm } from '@inertiajs/react';

import { Btn } from '@/Components/Btn';
import { PublicLayout } from '@/Layouts/PublicLayout';

type Props = {
    token: string;
    email: string;
};

export default function ResetPassword({ token, email }: Props) {
    const form = useForm({
        token,
        email,
        password: '',
        password_confirmation: '',
    });

    function submit(e: React.FormEvent) {
        e.preventDefault();
        form.post('/reset-password');
    }

    return (
        <PublicLayout>
            <Head title="Set new password" />
            <div className="max-w-md mx-auto px-6 py-12">
                <h1 className="text-[28px] leading-tight text-ink mb-3">Set a new password</h1>
                <form onSubmit={submit} className="space-y-4">
                    <input
                        type="email"
                        autoComplete="email"
                        required
                        value={form.data.email}
                        onChange={(e) => form.setData('email', e.target.value)}
                        className="w-full p-2 border border-rule rounded bg-card"
                    />
                    <input
                        type="password"
                        autoComplete="new-password"
                        required
                        value={form.data.password}
                        onChange={(e) => form.setData('password', e.target.value)}
                        className="w-full p-2 border border-rule rounded bg-card"
                        placeholder="New password"
                    />
                    <input
                        type="password"
                        autoComplete="new-password"
                        required
                        value={form.data.password_confirmation}
                        onChange={(e) => form.setData('password_confirmation', e.target.value)}
                        className="w-full p-2 border border-rule rounded bg-card"
                        placeholder="Confirm password"
                    />
                    {form.errors.password && <p className="text-[12px] text-red-700">{form.errors.password}</p>}
                    <Btn type="submit" full loading={form.processing}>
                        Reset password
                    </Btn>
                </form>
            </div>
        </PublicLayout>
    );
}
